import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import links from '../data/site-structure';
import { ActionsIcon } from './actions-icon';
import { StyledToolsLink, StyledLoginButton } from '../header.styled';
import { Link } from '@at/design-system-elements';
var testIdSignIn = 'account-sign-in';
var testIdSignOut = 'account-sign-out';
var LoginAction = function (_a) {
    var isNarrow = _a.isNarrow, userSignedIn = _a.userSignedIn, signedIn = _a.signedIn, signedOut = _a.signedOut, _b = _a.useNewSignIn, useNewSignIn = _b === void 0 ? false : _b, setShowSignInModal = _a.setShowSignInModal, trackingCallback = _a.trackingCallback;
    var _c = useState(false), showSubNav = _c[0], setShowSubNav = _c[1];
    var handleCloseSubmenu = function (e) {
        if (e.key === 'Escape' && showSubNav)
            setShowSubNav(false);
    };
    var handleMouseEnter = function () {
        if (!showSubNav)
            setShowSubNav(true);
    };
    var handleMouseLeave = function () {
        if (showSubNav)
            setShowSubNav(false);
        // @ts-ignore
        document.activeElement.blur();
    };
    return (React.createElement(React.Fragment, null,
        userSignedIn && isNarrow && (React.createElement(StyledLoginButton, { routerLink: false, href: signedIn.url, trackingCallback: trackingCallback, "data-testid": testIdSignOut },
            React.createElement(ActionsIcon, { name: "account" }),
            " ",
            signedIn.text)),
        userSignedIn && !isNarrow && (React.createElement(StyledLoginButton, { narrowHide: true, href: signedIn.url, trackingCallback: trackingCallback, onKeyDown: handleCloseSubmenu, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, "data-testid": testIdSignOut },
            React.createElement(ActionsIcon, { name: "account" }),
            " ",
            signedIn.text)),
        !userSignedIn && (React.createElement(React.Fragment, null, !useNewSignIn ? (React.createElement(StyledLoginButton, { href: signedOut.url, trackingCallback: trackingCallback, "data-testid": testIdSignIn },
            React.createElement(ActionsIcon, { name: "account" }),
            " ",
            signedOut.text)) : (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        React.createElement(StyledLoginButton, { as: "button", onClick: function (event) {
                event.preventDefault();
                trackingCallback === null || trackingCallback === void 0 ? void 0 : trackingCallback();
                if (setShowSignInModal)
                    setShowSignInModal(true);
            }, "data-testid": testIdSignIn },
            React.createElement(ActionsIcon, { name: "account" }),
            " ",
            signedOut.text))))));
};
export var Actions = function (_a) {
    var _b = _a.show, show = _b === void 0 ? true : _b, _c = _a.userSignedIn, userSignedIn = _c === void 0 ? false : _c, isNarrow = _a.isNarrow, _d = _a.useNewSignIn, useNewSignIn = _d === void 0 ? false : _d, setShowSignInModal = _a.setShowSignInModal, trackingCallback = _a.trackingCallback;
    var _e = useState(false), showAccountMenu = _e[0], setAccountMenuVisibility = _e[1];
    var _f = useState(''), referredUrl = _f[0], setReferredUrl = _f[1];
    var location = useLocation();
    var accountLinks = links.sharedHeader.account;
    useEffect(function () {
        setReferredUrl(location ? location.pathname + location.search : '');
    }, [showAccountMenu, location]);
    var handleOnFocus = function () {
        if (showAccountMenu)
            setAccountMenuVisibility(false);
    };
    var handleCloseSubmenu = function (e) {
        if (e.key === 'Escape' && showAccountMenu)
            setAccountMenuVisibility(false);
    };
    if (!show)
        return null;
    if (isNarrow) {
        return (React.createElement(LoginAction, { isNarrow: isNarrow, userSignedIn: userSignedIn, signedIn: {
                text: accountLinks.signedIn.mobileAccountText,
                url: '/secure/my-auto-trader',
            }, signedOut: {
                text: accountLinks.signedOut.mobileDisplayText,
                url: "".concat(accountLinks.signedOut.url).concat(referredUrl ? "?after-signin-url=".concat(referredUrl) : ''),
            }, useNewSignIn: useNewSignIn, setShowSignInModal: setShowSignInModal, trackingCallback: trackingCallback }));
    }
    else {
        return (React.createElement(React.Fragment, null,
            !userSignedIn && (React.createElement(React.Fragment, null, !useNewSignIn ? (React.createElement(StyledToolsLink, { as: Link, "$hideOn": 'narrow', href: "".concat(accountLinks.signedOut.url).concat(referredUrl ? "?after-signin-url=".concat(referredUrl) : ''), "aria-label": "Sign in to your Autotrader Account", trackingCallback: trackingCallback, "data-gui": testIdSignIn, "data-testid": testIdSignIn },
                React.createElement(ActionsIcon, { name: "account" }),
                isNarrow
                    ? accountLinks.signedOut.mobileDisplayText
                    : accountLinks.signedOut.desktopDisplayText)) : (React.createElement(StyledToolsLink, { as: "button", "$hideOn": "narrow", onClick: function () {
                    trackingCallback === null || trackingCallback === void 0 ? void 0 : trackingCallback();
                    if (setShowSignInModal) {
                        setShowSignInModal(true);
                    }
                }, onFocus: handleOnFocus, onKeyDown: handleCloseSubmenu, "data-gui": testIdSignIn, "data-testid": testIdSignIn },
                React.createElement(ActionsIcon, { name: "account" }),
                isNarrow
                    ? accountLinks.signedOut.mobileDisplayText
                    : accountLinks.signedOut.desktopDisplayText)))),
            userSignedIn && (React.createElement(React.Fragment, null,
                React.createElement(StyledToolsLink, { as: "a", "$hideOn": 'narrow', href: accountLinks.signedIn.url, onClick: function () { return trackingCallback === null || trackingCallback === void 0 ? void 0 : trackingCallback(); }, "data-testid": testIdSignOut },
                    React.createElement(ActionsIcon, { name: "account" }),
                    isNarrow
                        ? accountLinks.signedIn.mobileDisplayText
                        : accountLinks.signedIn.desktopDisplayText)))));
    }
};
